import LegalPageLayout from './LegalPageLayout';

export default function CGV() {
  return <LegalPageLayout pageKey="cgv" />;
}
